import { render, staticRenderFns } from "./page-5.vue?vue&type=template&id=255953c4&scoped=true&"
import script from "./page-5.vue?vue&type=script&lang=js&"
export * from "./page-5.vue?vue&type=script&lang=js&"
import style0 from "./page-5.vue?vue&type=style&index=0&id=255953c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255953c4",
  null
  
)

export default component.exports